// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import './styles.scss';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import validator from 'validator';
import InputField from 'components/commonComponents/InputField';
import Button from 'components/commonComponents/Button';

// icons

import TextArea from 'components/commonComponents/TextArea';

import ReCAPTCHA from "react-google-recaptcha";
import { APP_ID, RECAPTCHA } from 'config/constants';
import { Alert } from 'antd';
import { Fade } from 'react-reveal';
import { GlobalOutlined } from '@ant-design/icons';
import Appstore from 'assets/images/app_store.png';
import Playstore from 'assets/images/google_play.png';

// Verified links already used elsewhere in this app (Footer) — not
// fabricated handles for socials this app has no confirmed account for.
const STAY_IN_TOUCH = [
    { icon: <GlobalOutlined />, name: 'Electronic Village', handle: 'electronicvillage.org', href: 'https://electronicvillage.org' },
];

const Contact = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [error, setError] = useState('');
    const [errorAlert, setErrorAlert] = useState({ msg: '', key: Math.random(), open: false, severity: '' })
    const { name, email = '', phone, message, captcha } = data;

    const handleOnChange = (key) => (value) => {
        setError({
            ...error,
            [key]: null
        });
        setData({
            ...data,
            [key]: value
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const handleSubmit = async () => {
        const errors = {
            name: !name && 'Enter the name',
            email: (!email && 'Enter valid email') || (!validator.isEmail(email) && 'Enter valid email'),
            phone: (!phone && 'Enter valid phone') || (!validator.isNumeric(phone) && 'Enter valid phone'),
            message: !message && 'Enter the message',
            captcha: !captcha
        };
        setError(errors);
        let isFormValid = Object.values(errors).every((item) => !item);
        if (!isFormValid) return;
        setLoading(true);
        const formData = new FormData();
        formData.append('action', 'contact');
        formData.append('appId', APP_ID);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('phone', phone);
        formData.append('feedback', message);
        const res = await fetchData(restAPIs.contactUs(formData));
        if (res.statusCode === 200) {
            setData({})
            setError({})
            setErrorAlert({ msg: 'Your message has been sent successfully', key: Math.random(), open: true, severity: 'success' });
            setTimeout(() => {
                setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
            }, 3000);
        }
        else {
            setErrorAlert({ msg: res.errormessage, key: Math.random(), open: true, severity: 'error' });
            setTimeout(() => {
                setErrorAlert({ msg: '', key: Math.random(), open: false, severity: '' });
            }, 3000);
        }
        setLoading(false);

    }

    const onChange = (value) => {
        setError({
            ...error,
            captcha: null
        });
        setData({
            ...data,
            captcha: value
        });
    }


    return (
        <>
            <div className='container __innerTopPad'>
                <h1 className='__common-head'>{t('contact_us')}</h1>
                <p className='__contact_intro'>{t('contact_us_intro')}</p>

                {errorAlert && errorAlert.open &&
                    <Alert
                        type={errorAlert.severity === 'success' ? 'success' : 'error'}
                        message={errorAlert.msg}
                        showIcon
                        style={{ maxWidth: '640px', marginBottom: '20px' }}
                    />
                }

                <div className='__contact_layout'>
                    <Fade bottom cascade>
                        <div className='__contact_card'>
                            <div className='mb-4'>
                                <InputField
                                    type="text"
                                    label={t('name')}
                                    placeholder={t('name')}
                                    value={name}
                                    onChange={handleOnChange('name')}
                                    error={error.name}
                                />
                            </div>
                            <div className='mb-4'>
                                <InputField
                                    type="email"
                                    label={t('email')}
                                    placeholder={t('email')}
                                    value={email}
                                    onChange={handleOnChange('email')}
                                    error={error.email}
                                />
                            </div>
                            <div className='mb-4'>
                                <InputField
                                    type="number"
                                    label={t('phone')}
                                    placeholder={t('phone')}
                                    value={phone}
                                    onChange={handleOnChange('phone')}
                                    error={error.phone}
                                />
                            </div>
                            <div className='mb-4'>
                                <TextArea
                                    type="text"
                                    label={t('message')}
                                    placeholder={t('message')}
                                    value={message}
                                    onChange={handleOnChange('message')}
                                    height={180}
                                    error={error.message}
                                />
                            </div>
                            <div className='__contact_captcha'>
                                <label>{t('verification')}</label>
                                <ReCAPTCHA
                                    sitekey={RECAPTCHA}
                                    onChange={onChange}
                                />
                                {error.captcha && <p className='__contact_captcha_error'>Verify captcha</p>}
                            </div>
                            <Button
                                label={t('submit')}
                                handleOnClick={handleSubmit}
                                withLoader
                                loading={isLoading}
                                disabled={isLoading}
                                style={{ margin: 0 }}
                            />
                        </div>
                    </Fade>

                    <Fade bottom cascade>
                        <div className='__contact_touch'>
                            <h6>{t('stay_in_touch')}</h6>
                            {STAY_IN_TOUCH.map((item, idx) => (
                                <a key={idx} href={item.href} target='_blank' rel='noopener noreferrer' className='__contact_touch_item'>
                                    <span className='__contact_touch_icon'>{item.icon}</span>
                                    <span>
                                        <strong>{item.name}</strong>
                                        <em>{item.handle}</em>
                                    </span>
                                </a>
                            ))}
                            <div className='__contact_touch_stores'>
                                <a href="http://cinemaios.electronicvillage.org/" target="_blank" rel="noopener noreferrer"><img src={Appstore} alt="App Store" /></a>
                                <a href="http://cinemaandroid.electronicvillage.org/" target="_blank" rel="noopener noreferrer"><img src={Playstore} alt="Google Play" /></a>
                            </div>
                        </div>
                    </Fade>
                </div>
            </div>
        </>
    );
};

export default Contact;
